export default "__VITE_ASSET__rYVtOjOz__"